// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MovingModal__container___JaeDT {
    position: absolute;

    background-color: var(--color-bg-default);
    border: 0.1rem solid var(--color-bg-border);
    border-radius: 0.8rem;
    box-shadow: var(--shadow-modal);

    &[data-focused='true'] {
        /* Нужен, чтобы поднимать модалку, на которую кликнули */
        z-index: var(--focus-z-index);
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/model/MovingModal/MovingModal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;IAElB,yCAAyC;IACzC,2CAA2C;IAC3C,qBAAqB;IACrB,+BAA+B;;IAE/B;QACI,wDAAwD;QACxD,6BAA6B;IACjC;AACJ","sourcesContent":[".container {\n    position: absolute;\n\n    background-color: var(--color-bg-default);\n    border: 0.1rem solid var(--color-bg-border);\n    border-radius: 0.8rem;\n    box-shadow: var(--shadow-modal);\n\n    &[data-focused='true'] {\n        /* Нужен, чтобы поднимать модалку, на которую кликнули */\n        z-index: var(--focus-z-index);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MovingModal__container___JaeDT`
};
export default ___CSS_LOADER_EXPORT___;
